var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 155,
    viewBox: "0 0 271 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 143.939,
    cy: 48.8501,
    r: 190.209,
    transform: "rotate(-17.1547 143.939 48.8501)",
    fill: "url(#paint0_linear_831_271)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_831_271",
    x1: -2.43277,
    y1: -162.906,
    x2: 191.637,
    y2: 259.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.436568,
    stopColor: "#131519",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629417,
    stopColor: "#251463",
    stopOpacity: 0.565526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7967,
    stopColor: "#33139C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901332,
    stopColor: "#621F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6432"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsEllipse);
export default __webpack_public_path__ + "static/media/news-ellipse.fd1124647728dc2f960739ac084df03a.svg";
export { ForwardRef as ReactComponent };